import logo from './img/icon-logo-white.svg';
import logoMobile from './img/icon-logo.svg';

export const images = {
    logo: logo,
    logoMobile: logoMobile,
};